const CONTACT_ENDPOINT = process.env.REACT_APP_CONTACT_ENDPOINT;

export const sendContactMessage = async (payload) => {
  if (!CONTACT_ENDPOINT) {
    return {
      delivered: false,
      fallback: "mailto",
      reason: "missing_endpoint",
    };
  }

  const response = await fetch(CONTACT_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const body = await response.text().catch(() => "");
    throw new Error(body || "Failed to send contact message");
  }

  return {
    delivered: true,
    fallback: null,
    reason: null,
  };
};

